import { createApp } from 'vue'
import App from './App.vue'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import '@/assets/global.css'
import '@mdi/font/css/materialdesignicons.css'
import router from './router'
import vuetify from './plugins/vuetify'
import store from './store'
import cognitoPlugin from './plugins/cognito'
import createRouterHistoryPlugin from './plugins/routerHistory'

const app = createApp(App)
app.use(store)
app.use(cognitoPlugin)
app.use(router)
app.use(vuetify)
app.use(createRouterHistoryPlugin(router))
app.mount('#app')
